/* Confily — UI interactions + native Horizon cart-drawer integration.
   Header cart icon and best-seller "Add to cart" open the SAME cart drawer as
   the product page. Plain script (no ES module imports) for robustness. */
(function () {
  if (window.__confilyBooted) return;
  window.__confilyBooted = true;

  function routes() {
    return (window.Theme && window.Theme.routes) || {};
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return Promise.resolve(false);
    function doOpen() {
      try {
        if (typeof drawer.open === 'function') {
          if (!drawer.isOpen) drawer.open();
          return true;
        }
      } catch (e) { /* no-op */ }
      return false;
    }
    if (window.customElements && customElements.whenDefined) {
      return customElements.whenDefined('theme-drawer').then(function () {
        return new Promise(function (resolve) {
          requestAnimationFrame(function () { resolve(doOpen()); });
        });
      });
    }
    return Promise.resolve(doOpen());
  }

  function initCartToggle(root) {
    root.querySelectorAll('[data-cf-cart-toggle]').forEach(function (el) {
      if (el.__cfCartToggle) return;
      el.__cfCartToggle = true;
      el.addEventListener('click', function (e) {
        if (!document.getElementById('cart-drawer')) return;
        e.preventDefault();
        openCartDrawer();
      });
    });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cf-header__cart').forEach(function (cartLink) {
      var badge = cartLink.querySelector('.cf-header__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cf-header__count';
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function refreshDrawerFromSections(sections) {
    if (!sections) return false;
    var refreshed = false;
    Object.keys(sections).forEach(function (sid) {
      var wrapper = document.getElementById('shopify-section-' + sid);
      var htmlStr = sections[sid];
      if (!wrapper || !htmlStr) return;
      try {
        var doc = new DOMParser().parseFromString(htmlStr, 'text/html');
        var incoming = doc.getElementById('shopify-section-' + sid);
        if (incoming) {
          wrapper.replaceWith(incoming);
        } else {
          wrapper.innerHTML = htmlStr;
        }
        refreshed = true;
      } catch (e) { /* no-op */ }
    });
    return refreshed;
  }

  function initCart(root) {
    root.querySelectorAll('[data-cf-add]').forEach(function (btn) {
      if (btn.__cfAddBound) return;
      btn.__cfAddBound = true;
      btn.addEventListener('click', function (e) {
        var vid = btn.getAttribute('data-cf-add');
        if (!vid) return;
        e.preventDefault();
        var original = btn.textContent;
        btn.setAttribute('aria-busy', 'true');

        var sectionIds = Array.prototype.map
          .call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; })
          .filter(Boolean)
          .join(',');

        fetch(routes().cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: sectionIds })
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            btn.removeAttribute('aria-busy');
            btn.textContent = original;
            if (resp && resp.status) { console.warn('[confily-cart]', resp.message); return; }

            var didRefresh = refreshDrawerFromSections(resp && resp.sections);
            var afterRefresh = function () { openCartDrawer(); };

            if (!didRefresh) {
              var comp = document.querySelector('cart-items-component');
              if (comp && window.customElements && customElements.whenDefined) {
                customElements.whenDefined('cart-items-component').then(function () {
                  try {
                    if (typeof comp.fetchCartData === 'function') {
                      Promise.resolve(comp.fetchCartData()).then(afterRefresh, afterRefresh);
                      return;
                    }
                  } catch (e) { /* no-op */ }
                  afterRefresh();
                });
              } else {
                afterRefresh();
              }
            } else {
              afterRefresh();
            }

            fetch((routes().cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) { updateHeaderCount(cart.item_count); })
              .catch(function () { /* no-op */ });
          })
          .catch(function (err) {
            btn.removeAttribute('aria-busy');
            btn.textContent = original;
            console.warn('[confily-cart]', err);
          });
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-cf-faq-item]').forEach(function (item) {
      if (item.__cfBound) return;
      item.__cfBound = true;
      var btn = item.querySelector('[data-cf-faq-toggle]');
      var panel = item.querySelector('[data-cf-faq-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.closest('[data-cf-faq-list]').querySelectorAll('[data-cf-faq-item]').forEach(function (sib) {
          sib.setAttribute('data-open', 'false');
          var p = sib.querySelector('[data-cf-faq-panel]');
          var s = sib.querySelector('[data-cf-faq-sign]');
          if (p) p.style.maxHeight = '0px';
          if (s) s.textContent = '+';
        });
        if (!open) {
          item.setAttribute('data-open', 'true');
          panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
          var sign = item.querySelector('[data-cf-faq-sign]');
          if (sign) sign.textContent = '−';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function initCarousel(root) {
    root.querySelectorAll('[data-cf-carousel]').forEach(function (wrap) {
      if (wrap.__cfBound) return;
      wrap.__cfBound = true;
      var track = wrap.querySelector('[data-cf-track]');
      var prev = wrap.querySelector('[data-cf-prev]');
      var next = wrap.querySelector('[data-cf-next]');
      if (!track) return;
      var step = function () { return Math.min(track.clientWidth * 0.9, 360); };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-cf-video]').forEach(function (wrap) {
      if (wrap.__cfBound) return;
      wrap.__cfBound = true;
      wrap.addEventListener('click', function () {
        var vid = wrap.querySelector('video');
        var overlay = wrap.querySelector('[data-cf-video-overlay]');
        if (!vid) return;
        if (vid.paused) {
          vid.play();
          if (overlay) overlay.style.opacity = '0';
        } else {
          vid.pause();
          if (overlay) overlay.style.opacity = '1';
        }
      });
    });
  }

  function initNav(root) {
    root.querySelectorAll('[data-cf-nav-toggle]').forEach(function (btn) {
      if (btn.__cfBound) return;
      btn.__cfBound = true;
      btn.addEventListener('click', function () {
        var menu = document.getElementById(btn.getAttribute('data-cf-nav-toggle'));
        if (!menu) return;
        var open = menu.getAttribute('data-open') === 'true';
        menu.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initFaq(root);
    initCarousel(root);
    initVideos(root);
    initNav(root);
    initCartToggle(root);
    initCart(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
